import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { addMessage, addBatchName } from "state/reducers/smsBatching";
import { Input, InputContainer } from "components/common";
import Emojis from "../Emojis";
import "../../styles/marketing-dashboard.css";

const SMSChatBubble = ({ enabled, error, setError }) => {
  const [emojis, setEmojis] = useState(true);
  const message = useSelector((state) => state.smsBatching.message);
  const batchName = useSelector((state) => state.smsBatching.batchName);
  const dispatch = useDispatch();
  const handleMessageChange = (e) => {
    e.preventDefault();
    dispatch(addMessage(e.target.value));
  };
  const handleAddEmoji = (emoji) => {
    if (!message) {
      dispatch(addMessage(emoji));
    } else {
      dispatch(addMessage(message + emoji));
    }
  };
  const handleNameChange = (e) => {
    e.preventDefault();
    const invalid = /\/|\s|\\/;
    if (invalid.test(e.target.value)) {
      setError("*space and slash characters are not allowed");
    } else {
      setError(null);
      dispatch(addBatchName(e.target.value));
    }
    dispatch(addBatchName(e.target.value.trim()));
  };
  const handleAddBrackets = () => {
    if (!message) {
      dispatch(addMessage("{{}}"));
    } else {
      dispatch(addMessage(`${message} {{}}`));
    }
  };
  return (
    <>
      <p className="font-semibold">1. Add batch name</p>
      <InputContainer className="my-3">
        <Input
          placeholder="Batch name"
          onChange={(e) => handleNameChange(e)}
          value={batchName || ""}
        />
      </InputContainer>
      <small className="text-red-500">{error || null}</small>
      <p className="font-semibold text-left">2. Add message content</p>
      <div className="flex flex-row mt-3 border-2 rounded-lg border-gray-300 justify-center flex-wrap p-3">
        <div className="flex justify-center chat-bubble mt-3 mx-2">
          <textarea
            name="chat-bubble-preview"
            className="chat-bubble"
            cols="70"
            rows="6"
            disabled={enabled ? !enabled : true}
            placeholder="Welcome to TomoCredit..."
            value={message || ""}
            onChange={(e) => handleMessageChange(e)}
          />
        </div>
        {emojis && (
          <div className="mx-2">
            <div className="animate__animated animate__fadeIn my-auto mx-auto py-3">
              <Emojis handleAddEmoji={handleAddEmoji} />
            </div>
          </div>
        )}
      </div>
      <div className="flex flex-row justify-center mx-4 pr-1">
        <button
          type="button"
          className="bg-black-600 border-2 px-3 py-1 focus:outline-none active:outline-none my-2 mx-1"
          onClick={() => setEmojis(!emojis)}
        >
          <i className="fas fa-smile mr-1" />
          {emojis ? (
            <small style={{ fontSize: "0.6em", color: "red" }}>x</small>
          ) : (
            <small style={{ fontSize: "0.6em" }}>+</small>
          )}
        </button>
        <button
          type="button"
          className="bg-black-600 border-2 px-3 py-1 focus:outline-none active:outline-none my-2 mx-1"
          onClick={() => handleAddBrackets()}
        >
          <i className="fas fa-brackets-curly mr-1" />
          <small style={{ fontSize: "0.6em" }}>+</small>
        </button>
      </div>
      <div className="flex flex-row justify-center mx-auto">
        <p
          className={`text-center mb-2 mt-2 text-${
            message && message.length > 160 ? "red-500" : "black"
          }`}
        >
          <small>
            {message && message.length
              ? `character remaining ${160 - message.length}`
              : "characters remaining: 160"}
          </small>
        </p>
      </div>
    </>
  );
};

export default SMSChatBubble;
